<template>
  <div class="attend-box">
    <div class="todaybox">
      <div class="todaybox-tit title-font">
        <span>{{todayDate}}</span>
        <span style="margin-left: 5px;">{{todayWeek}}</span>
      </div>
      <div class="clearfix todaybox-tab">
        <div class="todaybox-tab-l clearfix fl">
          <div class="todaybox-tab-list">
            <span>
              <span class="todaybox-tab-name">上班时间</span>
              <span class="todaybox-tab-cont">{{todayTime.StartTimeName}}</span>
            </span>
            <span>
              <span class="todaybox-tab-name">打卡时间</span>
              <span class="todaybox-tab-cont">{{todayTime.FirstTimeName}}</span>
            </span>
            <span class="todaybox-tab-state">
              <span
                v-if="todayTime.FirstTeacherTypeName === '正常'"
                style="color:#19be6b;"
              >{{todayTime.FirstTeacherTypeName}}</span>
              <span
                v-else-if="todayTime.FirstTeacherTypeName === '迟到'"
                style="color:#f05a4a;"
              >{{todayTime.FirstTeacherTypeName}}</span>
              <span
                v-else-if="todayTime.FirstTeacherTypeName === '早退'"
                style="color:#f05a4a;"
              >{{todayTime.FirstTeacherTypeName}}</span>
              <span
                v-else-if="todayTime.FirstTeacherTypeName === '缺卡'"
                style="color:#f90;"
              >{{todayTime.FirstTeacherTypeName}}</span>
              <span
                v-else-if="todayTime.FirstTeacherTypeName === '外出'"
                style="color:#19be6b;"
              >{{todayTime.FirstTeacherTypeName}}</span>
              <span v-else style="color:#666;">{{todayTime.FirstTeacherTypeName}}</span>
            </span>
          </div>
          <div class="todaybox-tab-list">
            <span>
              <span class="todaybox-tab-name">下班时间</span>
              <span class="todaybox-tab-cont">{{todayTime.EndTimeName}}</span>
            </span>
            <span>
              <span class="todaybox-tab-name">打卡时间</span>
              <span class="todaybox-tab-cont">{{todayTime.LastTimeName}}</span>
            </span>
            <span class="todaybox-tab-state">
              <span
                v-if="todayTime.LastTeacherTypeName === '正常'"
                style="color:#19be6b;"
              >{{todayTime.LastTeacherTypeName}}</span>
              <span
                v-else-if="todayTime.LastTeacherTypeName === '迟到'"
                style="color:#f05a4a;"
              >{{todayTime.LastTeacherTypeName}}</span>
              <span
                v-else-if="todayTime.LastTeacherTypeName === '早退'"
                style="color:#f05a4a;"
              >{{todayTime.LastTeacherTypeName}}</span>
              <span
                v-else-if="todayTime.LastTeacherTypeName === '缺卡'"
                style="color:#f90;"
              >{{todayTime.LastTeacherTypeName}}</span>
              <span
                v-else-if="todayTime.LastTeacherTypeName === '外出'"
                style="color:#19be6b;"
              >{{todayTime.LastTeacherTypeName}}</span>
              <span v-else style="color:#666;">{{todayTime.LastTeacherTypeName}}</span>
            </span>
          </div>
        </div>
        <div v-if="shiftBtn" class="todaybox-tab-r fr">
          <button @click="SubmitAtt">
            <span>{{shiftName}}</span>
            <span>{{nowTimes}}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast } from "vant";
export default {
  data() {
    return {
      todayTime:{},
      todayDate: "",
      todayWeek: "",
      nowTimes: '',
      shift: "",
      shiftName: "上班打卡",
      shiftBtn: true
    };
  },
  created() {
    // 获取考勤时间
    console.log()
    this.GetByTodayTeacherId();
    this.getData()
  },
  methods: {
    forState: function (data) {
      switch (data) {
        case '1':
          return '星期一'
        case '2':
          return '星期二'
        case '3':
          return '星期三'
        case '4':
          return '星期四'
        case '5':
          return '星期五'
        case '6':
          return '星期六'
        case '7':
          return '星期日'
        default:
          return ''
      }
    },
    async GetByTodayTeacherId() {
      let res = await this.xyapi.get(
        this.$store.state.apiPath +
          "/api/TeacherAttendanceRecord/GetByTodayTeacherId"
      );
      this.todayTime = res.data;
      this.todayDate = this.xy.moment(this.todayTime.ServerNowTime).format('YYYY-MM-DD')
      this.todayWeek = this.forState(this.xy.moment(this.todayTime.ServerNowTime).format('d'));

      // 判断是否上班已经打过卡
      if (this.todayTime.FirstTeacherTypeID === 0) {
        this.shift = true;
        this.shiftBtn = true;
        console.log("需要上班打卡");
      } else {
        this.shift = false;
        this.shiftBtn = true;
        this.shiftName = "下班打卡";
        console.log("已经打过上班卡");
        console.log(this.shiftBtn);
      }

      // 判断是否下班已经打过卡
      if (this.todayTime.LastTeacherTypeID === 0) {
        // shift = true;
        this.shiftBtn = true;
        console.log("还没下班");
      } else {
        this.shift = false;
        this.shiftBtn = false;
        this.shiftName = "下班打卡";
        console.log("已经下班");
        console.log(this.shiftBtn);
      }
    },
    async SubmitAtt() {
      var that = this;
      // 当前
      var currentTime = this.xy.moment().format("HH:mm:ss");
      // 上班
      // var StartTime = that.todayTime.StartTime;
      // 下班
      var EndTime = that.todayTime.EndTime;
      if (that.shift === true) {
        // 上班
        let res = await this.xyapi.post(
          this.$store.state.apiPath +
            "/api/TeacherAttendanceRecord/CreateFirstTime"
        );
        if (res.success) {
          console.log("---------------上班----------------");
          that.GetByTodayTeacherId();
          Toast.success("上班打卡成功！");
          that.shiftName = "下班打卡";
        }
      } else {
        // 如果当前时间 < 下班时间

        console.log(currentTime);
        console.log(EndTime);
        if (currentTime < EndTime) {
          // 早退
          this.xy.confirm("早退打卡", "您确认要早退打卡吗？", () => {
              console.log("早退");
              this.zaotui();
          });
        } else {
          // 正常下班
          console.log("下班");
          this.endWork();
        }
      }
    },
    async zaotui() {
      let res = await this.xyapi.post(
        this.$store.state.apiPath +
          "/api/TeacherAttendanceRecord/CreateLastTime"
      );
      if (res.success) {
        console.log("---------------早退----------------");
        this.GetByTodayTeacherId();
        Toast.success("早退打卡成功！");
        this.shiftBtn = false;
      }
    },
    async endWork() {
      // 下班
      let res = await this.xyapi.post(
        this.$store.state.apiPath +
          "/api/TeacherAttendanceRecord/CreateLastTime"
      );
      if (res.success) {
        console.log("---------------下班----------------");
        this.GetByTodayTeacherId();
        Toast.success("下班打卡成功！");
        this.shiftBtn = false;
      }
    },
    getData() {
        var t = new Date();//创建一个date的对象，才可以引用相关的date
        var h = t.getHours();
        var m = t.getMinutes();
        var s = t.getSeconds();
        this.nowTimes = h + ':' + m + ':' + s;
        let _this = this;
        setTimeout(() => {
          _this.getData();
        }, 1000);
    },
  }
};
</script>
<style lang="less">
.attend-box {
  background: #fff;
  padding: 10px 15px 0;
  height: 100%;
  .todaydate {
    float: inherit;
    display: block;
    font-size: 18px;
    padding: 16px;
    border-bottom: 1px solid #eaeaea;
  }
  .todaybox {
    .todaybox-tit {
      display: block;
      height: 64px;
      line-height: 64px;
    }
    .todaybox-tab {
      .todaybox-tab-l {
        float: inherit;
        vertical-align: middle;
        .todaybox-tab-list {
          display: block;
          position: relative;
          span {
            display: block;
            white-space: nowrap;
            vertical-align: middle;
            span {
              height: 120px;
              line-height: 120px;
              vertical-align: middle;
            }
            .todaybox-tab-name {
              font-size: 33px;
              width: 120px;
              text-align: center;
              display: inline-block;
            }
            .todaybox-tab-cont {
              font-size: 30px;
              width: 80px;
              text-align: center;
              display: inline-block;
              // text-indent: 50%;
              margin-left: 45px;
            }
          }
          span:first-child > .todaybox-tab-cont {
            font-size: 30px;
            width: 80px;
            text-align: center;
            display: inline-block;
            // text-indent: 50%;
            margin-left: 45px;
          }
          .todaybox-tab-state {
            position: absolute;
            bottom: 0px;
            left: 300px;
            border: 1px solid #fff;
            border-radius: 3px;
            padding: 2px 8px;
          }
        }
      }
      .todaybox-tab-r {
        float: inherit;
        margin-top: 30px;
        button {
          display: block;
          outline: none;
          border: none;
          width: 220px;
          height: 220px;
          border-radius: 50%;
          cursor: pointer;
          background: -webkit-linear-gradient(#66cffe, #2b7aeb);
          background: -o-linear-gradient(#66cffe, #2b7aeb);
          background: -ms-linear-gradient(#66cffe, #2b7aeb);
          background: -moz-linear-gradient(#66cffe, #2b7aeb);
          background: linear-gradient(#66cffe, #2b7aeb);
          overflow: hidden;
          box-shadow: 0px 0px 24px 0px #8d9bb5;
          transition: all 0.3s;
          margin: 20px auto 50px auto;
          span {
            display: block;
            color: #fff;
            text-align: center;
            margin-top: 10px;
          }
          span:first-child {
            font-size: 30px;
            font-weight: bold;
          }
          span:last-child {
            font-size: 30px;
          }
        }
        button:hover {
          transition: all 0.3s;
          opacity: 0.8;
          box-shadow: 0px 0px 15px 0px #8d9bb5;
        }
      }
    }
  }
}
</style>
